import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { ProductThumb } from "../dashboard/recent-order";
import { OrderStatusBadge } from "./order-status-badge";
import { OrdersActionsMenu } from "./orders-actions-menu";

export function OrdersRow({ order, onViewDetails }) {
  return (
    <TableRow
      sx={{
        "&:last-child td": { borderBottom: "none" },
        "& td": {
          borderColor: "#F0F0F0",
          py: 2,
          fontSize: "13px",
          overflow: "hidden",
        },
      }}
    >
      <TableCell>
        <span className="font-semibold text-[#1F2937]">#{order.orderId}</span>
      </TableCell>
      <TableCell>
        <div>
          <p className="my-0 font-semibold text-[#1F2937]">{order.customerName}</p>
          <p className="my-0 mt-0.5 text-[12px] font-medium text-[#9CA3AF]">
            {order.customerCity}
          </p>
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-3">
          <ProductThumb src={order.raw?.product?.images?.[0]} alt="" />
          <div className="min-w-0">
            <p className="my-0 truncate font-semibold text-[#1F2937]">
              {order.productName}
            </p>
            <p className="my-0 mt-0.5 text-[11px] font-medium text-[#9CA3AF]">
              {order.sku}
            </p>
          </div>
        </div>
      </TableCell>
      <TableCell>
        <span className="tabular-nums font-medium text-[#374151]">
          {order.quantity}
        </span>
      </TableCell>
      <TableCell>
        <span className="font-semibold text-[#1F2937]">{order.price}</span>
      </TableCell>
      <TableCell align="center">
        <div className="flex justify-center">
          <OrderStatusBadge status={order.status} />
        </div>
      </TableCell>
      <TableCell align="center">
        <div className="flex justify-center">
          <OrdersActionsMenu order={order} onViewDetails={onViewDetails} />
        </div>
      </TableCell>
    </TableRow>
  );
}
